var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountantsSubmenu',{attrs:{"items":_vm.menuItems},scopedSlots:_vm._u([{key:"titletop",fn:function(){return undefined},proxy:true},{key:"bottom",fn:function(){return undefined},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }